import Vue from "vue";
import Vuex from "vuex";
import VuexPersist from "vuex-persist";

import alert from '@/store/modules/alert-module';
import account from '@/store/modules/account-module';
import hotel from '@/store/modules/hotel-module'

Vue.use(Vuex);

const vuexPersist = new VuexPersist({
  key: 'state',
  storage: window.localStorage,
  reducer: state => ({
    hotel: state.hotel
  })
});

const store = new Vuex.Store({
  modules: {
    alert,
    account,
    hotel
  },
  plugins: [vuexPersist.plugin]
});

export default store;